import Vue from 'vue'
import VueRouter from 'vue-router'
import First from '../views/First.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'first',
    component: First
  },
  {
    path: '/title',
    name: 'title',
    component: () => import('../views/Title.vue')
  },
  {
    path: '/new',
    name: 'new',
    component: () => import('../views/New.vue')
  },
  {
    path: '/newsub',
    name: 'newsub',
    component: () => import('../views/NewSub.vue')
  },
  {
    path: '/result',
    name: 'result',
    component: () => import('../views/Result.vue')
  },
  {
    path: '/result/:id',
    name: 'result-id',
    component: () => import('../views/Result.vue')
  },
  {
    path: '/battle/:id',
    name: 'battle',
    component: () => import('../views/Battle.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/Profile.vue')
  },
  {
    path: '/miniicon',
    name: 'miniicon',
    component: () => import('../views/MiniIcon.vue')
  },
  {
    path: '/setting',
    name: 'setting',
    component: () => import('../views/Setting.vue'),
    beforeEnter (to, from, next) {
      if(store.getters.test == null){
        next()
      }else{
        next(false)
      }
    }
  },
  {
    path: '/action',
    name: 'action',
    component: () => import('../views/Action')
  },
  {
    path: '/makeevent',
    name: 'makeEvent',
    component: () => import('../views/MakeEvent.vue')
  },
  {
    path: '/status',
    name: 'status',
    component: () => import('../views/Status.vue')
  },
  {
    path: '/status/:id',
    name: 'status-id',
    component: () => import('../views/Status.vue')
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/List.vue')
  },
  {
    path: '/world',
    name: 'world',
    component: () => import('../views/WorldList.vue')
  },
  {
    path: '/world/:id',
    name: 'world-detail',
    component: () => import('../views/WorldNote.vue')
  },
  {
    path: '/tv',
    name: 'tv',
    component: () => import('../views/Tv.vue')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import(/* webpackChunkName: "help" */ '../views/HelpTop.vue')
  },
  {
    path: '/help/game',
    name: 'help-game',
    component: () => import(/* webpackChunkName: "help" */ '../views/HelpGame.vue')
  },
  {
    path: '/help/etc',
    name: 'help-etc',
    component: () => import(/* webpackChunkName: "help" */ '../views/HelpEtc.vue')
  },
  {
    path: '/help/qa',
    name: 'help-qa',
    component: () => import(/* webpackChunkName: "help" */ '../views/HelpQA.vue')
  },
  {
    path: '/help/dicebattle',
    name: 'help-dicebattle',
    component: () => import(/* webpackChunkName: "help" */ '../views/HelpDiceBattle.vue')
  },
  {
    path: '/help/data',
    name: 'help-data',
    component: () => import(/* webpackChunkName: "help" */ '../views/HelpData.vue')
  },
  {
    path: '/spot',
    name: 'spot',
    component: () => import(/* webpackChunkName: "spot" */ '../views/Spot')
  },
  {
    path: '/spot/:id',
    name: 'spot-id',
    component: () => import(/* webpackChunkName: "spot" */ '../views/Spot/Edit')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "help" */ '../views/News.vue')
  },
  {
    path: '/special',
    name: 'special',
    component: () => import('../views/Special.vue')
  },
  {
    path: '/map',
    name: 'map',
    component: () => import('../views/Map')
  },
  {
    path: '/myworld',
    name: 'myworld',
    component: () => import('../views/MyWorld')
  },
  {
    path: '/announce',
    name: 'announce',
    component: () => import('../views/TvAnnounce')
  },
  {
    path: '/dicebattle',
    name: 'DiceBattle',
    component: () => import('../views/DiceBattle.vue')
  },
  {
    path: '/world-edit/:id',
    component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor'),
    children: [{
      path: '',
      name: 'world-edit',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/Base')
    },{
      path: '/base',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/Base')
    },{
      path: '/rule',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/Rule')
    },{
      path: '/main-action',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/MainAction')
    },{
      path: '/area',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/Area')
    },{
      path: '/quest/:area/:key',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/Quest')
    },{
      path: '/test',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/Test')
    },{
      path: '/card',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/CardList')
    },{
      path: '/card/:index',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/Card')
    },{
      path: '/impcard/:index',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/ImportCard')
    },{
      path: '/npc/:area/:key',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/Npc')
    },{
      path: '/buff',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/BuffList')
    },{
      path: '/buff/:index',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/Buff')
    },{
      path: '/impbuff/:index',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/ImportBuff')
    },{
      path: '/achievement',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/AchievementList')
    },{
      path: '/achievement/:index',
      component: () => import(/* webpackChunkName: "world" */ '../views/WorldEditor/Achievement')
    }]
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/Admin'),
    beforeEnter (to, from, next) {
      if(store.getters.admin){
        next()
      }else{
        next(false)
      }
    }
  },
  {
    path: '/editchara',
    name: 'adminCharacter',
    component: () => import('../views/AdminCharacter/List')
  },
  {
    path: '/editchara/:id',
    name: 'adminCharacter-id',
    component: () => import('../views/AdminCharacter')
  },
  {
    path: '/change/:no',
    name: 'change',
    component: () => import('../views/Change.vue')
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/Logout.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
